import {
  API_ROOT,
  dispatchGetJSONAsync,
  dispatchPostJSONAsync,
  completeJSONAsync,
} from './BaseApi';
import appdata from '../Services/appdata';

const ApiReportSetting = () => {
  const getReportSetting = async () => {
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');
    const user_id = appdata.getItem('user').id;

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/reportsetting/${company_id}/get/${company_org_id}/${user_id}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const updateReportSetting = async (update_setting) => {
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');
    const user_id = appdata.getItem('user').id;

    let task = await dispatchPostJSONAsync(
      `${API_ROOT}/reportsetting/${company_id}/update/${company_org_id}`,
      {
        user_id,
        ...update_setting,
      },
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getReportSetting,
    updateReportSetting,
  };
};

export default ApiReportSetting();
